import { Box } from '@mui/material';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  UserState,
  useUserStore,
} from '../../modules/user/stores/use-user.store';
import { ImageFallback } from '../../shared/components/ImageFallback/ImageFallback';
import { useFetch } from '../../shared/hooks/use-fetch.hook';
import { useShared } from '../../shared/hooks/use-shared.hook';
import styles from '../tool/components/ToolMultiElementTable.module.scss'; // TODO delete
import { ToolFavorite } from '../../modules/dashboard/models/dashboard.types';
import {
  Contact,
  ContactAction,
} from '../../modules/contacts/models/contacts.types';
import { ImageFallbackType, MenuItem } from '../../shared/models/shared.types';
import { H2 } from '../../shared/ui/H2/H2';
import { IconButton } from '../../shared/ui/IconButton/IconButton';
import { AddButton } from '../../shared/ui/AddButton/AddButton';
import { FavoriteTool } from '../../modules/dashboard/components/WidgetFavoriteTools/WidgetFavoriteTools';
import { H3 } from '../../shared/ui/H3/H3';

type ContactDetailProps = {
  //   contactCommunity: ContactCommunity;
  //   selectedContactId: string;
  //   contacts: Contact[];
  //   heightClass: string;
  //   memberRole?: CommunityUserRole;
  //   addTool?: boolean;
  //   setContacts: (contacts: Contact[]) => void;contact
  contact: Contact;
  onClose: () => void;
};

const ContactDetail = memo(({ contact, onClose }: ContactDetailProps) => {
  const { handleError, handleRetry } = useFetch();
  const { fullNameGet } = useShared();
  const { t } = useTranslation();
  const [account] = useUserStore((state: UserState) => [state.account]);

  // Component state
  const [tools, setTools] = useState<ToolFavorite[]>([]);
  const [dialogAddTools, setDialogAddTools] = useState<boolean>(false);

  // ##### //
  // FORMS //
  // ##### //

  // ######### //
  // MUTATIONS //
  // ######### //

  // ####### //
  // EFFECTS //
  // ####### //

  // ######### //
  // CALLBACKS //
  // ######### //

  const menuItems: MenuItem[] = [
    {
      action: ContactAction.Message,
      icon: ['fal', 'message-lines'],
      title: t('contacts.actions.message'),
    },
    {
      action: ContactAction.Upgrade,

      icon: ['fal', 'arrow-up-big-small'],
      title: t('contacts.detail.tooltip.upgrade'),
    },
    {
      action: ContactAction.Downgrade,

      icon: ['fal', 'arrow-down-big-small'],
      title: t('contacts.detail.tooltip.downgrade'),
    },
    {
      action: ContactAction.Delete,

      icon: ['fal', 'trash'],
      title: t('app.actions.delete'),
    },
  ];

  return (
    <Box className="flex flex-col w-full min-h-full p-4 pr-2 pt-1 rounded-md items-start relative overflow-y-auto">
      {contact && (
        <div className="w-full flex flex-col justify-between">
          <IconButton
            classes="self-end"
            padding="0.25rem"
            icon={['fas', 'times']}
            onClick={onClose}
          />
          <Box>
            <H2 color="primary.main" marginTop="0">
              Zur Person
            </H2>
          </Box>
          <div className="flex mb-4 pr-2 w-fit max-w-full flex-row gap-3">
            <div className="flex flex-col">
              {contact.avatar?.url ? (
                <img
                  alt="User Avatar"
                  className="h-24 rounded-md w-24"
                  src={contact.avatar.url}
                />
              ) : (
                <ImageFallback
                  iconSize="3em"
                  sizeClassName="h-24 rounded-md w-24"
                  type={ImageFallbackType.Profile}
                />
              )}
            </div>
            <div className="flex flex-col w-fit gap-1">
              <H3 classes="w-fit" marginTop="0" marginBottom="0">
                {fullNameGet(contact.first_name, contact.last_name)}{' '}
              </H3>
              {contact.email && <div>{contact.email}</div>}
              {contact.phone && <div>{contact.phone}</div>}
              <div className="flex w-full">
                {menuItems.map((menuItem, index) => {
                  return (
                    <Box
                      className={styles['contact-detail-action']}
                      onClick={() => {}}
                    >
                      <IconButton
                        classes={styles['contact-detail-action-icon']}
                        icon={menuItem.icon || ['fal', 'trash']}
                        iconSize="inherit"
                        sxIcon={{
                          color: index === 3 ? 'error.main' : 'primary.main',
                        }}
                      />
                    </Box>
                  );
                })}
              </div>
            </div>
          </div>

          <Box>
            <H3>Tools im Einsatz</H3>
          </Box>
          <div className="grow flex flex-row max-w-full">
            <Box className="flex" sx={{ backgroundColor: 'background.paper' }}>
              <Box className="p-2 w-[130px] lg:w-[calc(145px-24px)] shrink-0">
                <AddButton
                  heightClassName="h-full"
                  widthClassName="w-full"
                  onClick={() => setDialogAddTools(true)}
                >
                  {t('contacts.detail.tools.add')}
                </AddButton>
              </Box>
              {tools.map((tool, index) => (
                <FavoriteTool
                  key={index}
                  tool={tool}
                  heightClasses="h-full"
                  classes="p-2 w-[130px] lg:w-[calc(145px-24px)] shrink-0"
                />
              ))}
            </Box>
          </div>
        </div>
      )}
    </Box>
  );
});

export default ContactDetail;
